import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import Storage from 'vue-web-storage'; 
import VueAwesomeSwiper from 'vue-awesome-swiper'

const storage_prefix = process.env.VUE_APP_STORAGE_PREFIX;
Vue.use(Storage, {
  prefix: storage_prefix,// default `app_`
  drivers: ['session','local'], // default 'local'
}); 
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
